import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const issueNavigatorProjectClassicRoute: InvariantJiraRoute = {
	name: 'issue-navigator-classic',
	path: '/jira/software/c/projects/:projectKey/issues/:navigationItemId?',
};
